<template>
  <multiselect
      v-bind:value="internalItems"
      track-by="statevalue"
      label="name"
      placeholder="Search"
      v-bind:options="options"
      v-bind:multiple="true"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      v-bind:close-on-select="false"
      v-bind:clear-on-select="false"
      v-on:input="setItems"
  >
    <template slot="selection" slot-scope="{ values, search, isOpen }">
      <span
          v-if="values.length > (displayCutoff || 5) && !isOpen"
          v-bind:class="{'someselected': values.length !== options.length}"
      >{{ values.length }} selected</span>
      <span
          v-else-if="values.length && !isOpen"
          v-bind:class="{'someselected': values.length !== options.length}"
      >{{ values.map(x => x.name).join(', ') }}</span>
    </template>
    <template slot="beforeList">
      <button
          v-bind:disabled="internalItems.length === options.length"
          v-on:click="reset()"
      >Select All</button>
    </template>
    <template slot="tag">
      <span></span>
    </template>
  </multiselect>
</template>
<script>
export default {
  name: 'invertSelect',
  props: ['options', 'currentlySelected', 'displayCutoff'],
  data: function (){
    return {
      internalItems: [],
    }
  },
  methods: {
    reset: function () {
      this.setItems(this.options);
    },
    setItems: function (ids) {
      let old_items_lookup = {};
      this.internalItems.forEach(o => old_items_lookup[o.statevalue] = o);
      if (ids.length === 0) {
        if (this.internalItems.length === 1) {
          this.internalItems = this.options.filter(c => c.statevalue !== this.internalItems[0].statevalue);
        } else {
          this.internalItems = this.options;
        }
      } else if (ids.length + 1 === this.options.length && this.internalItems.length === this.options.length) {
        this.internalItems = [this.options.find(c => !ids.includes(c))];
      } else {
        this.internalItems = ids;
      }
      this.$emit('input', this.internalItems);
    },
  },
  computed: {
    itemLookup: function () {
      let lookup = {};
      this.options.forEach(o => lookup[o.statevalue] = o);
      return lookup;
    },
  },
  watch: {
    currentlySelected: {
      immediate: true,
      handler: function () {
        if (!this.currentlySelected || !this.currentlySelected.length) {
          this.internalItems = this.options;
        } else {
          this.internalItems = this.currentlySelected.map(c => this.itemLookup[c.statevalue]).filter(c => c);
        }
      },
    },
  }
}
</script>
<style scoped>
    /deep/ .multiselect__option--selected.multiselect__option--highlight {
      background: #41b883;
    }

    /deep/ .multiselect__option--selected.multiselect__option--highlight:after {
      background: #41b883;
    }

    /deep/ .multiselect__option--group-selected.multiselect__option--highlight {
      background:#41b883;
    }

    /deep/ .multiselect__option--group-selected.multiselect__option--highlight:after {
      background: #41b883;
    }

    /deep/ .multiselect__option>span:before {
      content: "☐ ";
    }

    /deep/ .multiselect__option--selected>span:before {
      content: "☑ ";
    }

    /deep/ .multiselect__tags>input {
        margin-top: 10px;
    }

    /deep/ .someselected {
        font-weight: bold;
        color: #000;
    }

    /deep/ .multiselect__option {
      line-height: 0.8em;
      font-size: 0.8em;
    }
</style>
